export const groupColors = [
  { color: "#0d95d9", backgroundColor: "#e4f6ff" },
  { color: "#4b76b2", backgroundColor: "#e0edfd" },
  { color: "#4b60b2", backgroundColor: "#e0e6fd" },
  { color: "#544ac8", backgroundColor: "#e5e4f6" },
  { color: "#b624c5", backgroundColor: "#fdeaff" },
  { color: "#cc3277", backgroundColor: "#ffe0ee" },
  { color: "#db221e", backgroundColor: "#ffebea" },
  { color: "#e5711a", backgroundColor: "#fff3ea" },
  { color: "#dbaa0a", backgroundColor: "#fff4c5" },
  { color: "#a1b514", backgroundColor: "#f5ffc5" },
  { color: "#809b15", backgroundColor: "#e8ffc5" },
  { color: "#2f7f07", backgroundColor: "#e2f2da" },
  { color: "#49947e", backgroundColor: "#d9f9f0" },
  { color: "#498594", backgroundColor: "#d9f3f9" },
] as const;
